
<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" color="#FEBD08" :timeout="timeout" app right >
      <v-layout wrap>
        <v-flex xs11>
         {{msg}}
        </v-flex>
        <v-flex xs1> <v-icon @click="snackbar=!snackbar">mdi-close</v-icon>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout pt-5 pl-md-3 pl-lg-5 wrap>
      <v-flex>
        <div class="RM clr">SELLER PORTAL</div>
        <div class="head">Sold Details </div>
        <div ><span class="RB" >OrderId</span>  <span style="color:green">#{{orderData.orderID}}</span></div>
      </v-flex>
    </v-layout>
    <v-layout pl-md-3 pl-lg-5 wrap >
      <v-flex xs12 md8>
        <v-layout wrap v-for="(item, i) in soldproducts" :key="i" py-2>
          <v-flex xs12 sm2 md2 pb-3 pb-md-0 >
            <v-img
              height="90px"
              width="90px"
              cover
              :src="mediaURL + item.productId.photos[0]"
            >
            </v-img>
          </v-flex>
          <v-flex  xs12 sm10 align-self-center>
            <v-layout wrap pl-lg-3>
              <v-flex xs5 sm3 md3>
                <div class="medium clr RG">Product Name</div>
                <div class="RB medium">{{item.name}}</div>
              </v-flex>

              <v-flex xs4 sm3 md2>
                <div class="medium clr RG"> Quantity</div>
                <div class="RB medium">{{item.quantity}}</div>
              </v-flex>
              <v-flex xs3 sm2 md2  >
                <div class="medium clr RG">Total</div>
                <div class="RB medium">₹{{item.productTotalAmount}}</div>
              </v-flex>
              <!-- <v-flex xs6 sm2 md2 pt-3 pt-sm-0 pt-md-0>
                <div class="medium clr RG">Total Sale</div>
                <div class="RB medium">₹3,45,678</div>
              </v-flex> -->
              <v-flex xs6 sm2 md3 dense pr-3 pt-3 pt-sm-0>
                <v-select class="textfd" :label="item.productOrderStatus" outlined dense v-model="item.statusValue" @change="changeStatus(item)" :items="paymentStatus" ></v-select>
              </v-flex>
              <v-flex xs6 sm2 md2 pt-3 pt-sm-0>
               
                <v-btn tile color="#FEBD08"
                :href="
                      baseURL +
                      '/order/invoice/pdf?orderid=' +
                      orderId +
                      '&productid=' +
                      item._id
                    "> Invoice

                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pt-4 pr-lg-1>
            <v-divider> </v-divider>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md4 style="border-left: 1px solid #D5D5D5">
        <v-layout wrap px-3 py-5>
          <v-flex xs12 class="RB medium" pb-5> ADDRESS </v-flex>
          <v-flex xs12 class="RB medium" pb-3> {{billingAddress.firstName}}</v-flex>
          <v-flex xs12 class="RB medium" pb-3
            >{{billingAddress.address}}
          </v-flex>
          <v-flex xs12 pb-2>
            <span style="padding-right:2%"><v-icon color="#FEBD08">mdi-phone-outline</v-icon></span> <span >{{billingAddress.phone}}</span>
          </v-flex>
          <v-flex xs12 pb-3>
            <span style="padding-right:2%"><v-icon color="#FEBD08">mdi-email-outline</v-icon></span>
            <span>{{billingAddress.email}}</span>
          </v-flex>
          <v-flex xs12 pt-5>
            <v-layout wrap>
              <v-flex xs6 class="regulartext">Subtotal </v-flex>
              <v-flex xs6 text-right class="RM">Rs.{{subTotal}}  </v-flex>
              <v-flex xs6 class="regulartext">Shipping</v-flex>
              <v-flex xs6 text-right class="RM">Free</v-flex>
              <v-flex xs12 py-3>
                <v-divider> </v-divider>
              </v-flex>
              <v-flex xs6 class="regulartext">Total </v-flex>
              <v-flex xs6 text-right class="RM" style="font-size: 23px"
                >Rs.{{totalAmount}}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      orderData:[],
      appLoading:false,
      snackbar:false,
      timeout:3000,
      msg:"",
      soldproducts: [],
      billingAddress:[],
      subTotal:"",
      totalAmount:"",
      paymentStatus:['Packed', 'Shipped', 'Cancelledbyseller', 'Outfordelivery', 'Delivered'],
      statusValue:"",
      orderId:null
    };
  },
  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      this.appLoading =true;
      axios({
        method: "get",
        url: "/seller/order/view/" + this.$route.query.productId,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          this.soldproducts = response.data.data.products;
          this.billingAddress =response.data.data.billingAddress;
          this.subTotal = response.data.subTotal;
          this.totalAmount = response.data.totalAmount;
          this.orderId = response.data.data._id
          this.orderData = response.data.data
          // if(response.data.data.paymentStatus)
          // {
          //   this.statusValue = response.data.data.paymentStatus
          // }
          console.log(this.statusValue,"the value issss");
        }
         this.appLoading =false;
      });
    },
    changeStatus(item)
    {
        axios({
        method: "post",
        url: "/seller/ordered/product/status/change" ,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data:
        {
          orderid :this.orderId,
          productid :item._id,
          productOrderStatus:item.statusValue
        }
      })
      .then((response) =>{
        if(response.data.status)
        {
         this.snackbar =true;
         this.msg = response.data.msg;
        }

      })
    },
  
  },
};
</script>